module.exports = {
    name: "Transmission",

    base: {
        contact_address: "FREEPOST MORECAMBE AND MORGAN",
        contact_number: "0800 915 2493 (option 3)",
        contact_email: "info@morecambeandmorgan.com",
    },

    form: {
        "register": {
            "catcher_id": "e1acd815df16",
            "recaptcha": "6Lew3SMUAAAAAJ82QoS7gqOTkRI_dhYrFy1f7Sqy",
            "honeypot": ""
        }
    },

    consultation: {
        mapId: 3,
        mapSlug: "/transmission/map",

        // Ensure this URL does NOT have a trailing slash on the URL. Map reporting will fail.
        mapUrl: "https://feedback.morecambeandmorgan.com",
        //mapUrl: "https://bp-mmt-map.jfd-test.co.uk",
        //mapUrl: "http://bp-mmt-map.test",

        feedback_active: true,
        closed_message: "This consultation is closed and is no longer accepting feedback.",
        review_url: "/transmission/have-your-say/form/review/",

        // Consultation close countdown. If set to true, show countdown in site header
        has_countdown: false,

        hasMap: true,

        sections: [
            {
                name: "Your details",
                slug: "your-details",
                icon: "your-details",

                questions: [
                    {
                        label: "Title",
                        name: "17-title",
                        required: true,
                        type: "text",
                        placeholder: "(Mr/Mrs/Miss/Dr)"
                    },
                    {
                        label: "First name",
                        name: "18-first_name",
                        required: true,
                        type: "text",
                        placeholder: "Enter your first name"
                    },
                    {
                        label: "Last name",
                        name: "19-last_name",
                        required: true,
                        type: "text",
                        placeholder: "Enter your last name"
                    },
                    {
                        label: "Company/organisation",
                        name: "20-organisation",
                        required: false,
                        type: "text",
                        placeholder: "Company / organisation, if applicable (optional)"
                    },
                    {
                        label: "Address",
                        name: "21-address",
                        required: true,
                        type: "text",
                        placeholder: "Enter your address"
                    },
                    {
                        label: "Postcode",
                        name: "22-postcode",
                        required: false,
                        type: "text",
                        placeholder: "Enter your postcode (optional)"
                    },
                    {
                        label: "Email",
                        name: "23-email",
                        required: false,
                        type: "email",
                        placeholder: "Enter your email"
                    },
                    {
                        label: "How would you describe your interest in the Project?",
                        name: "24-interest",
                        required: false,

                        options: [
                            {
                                label: "Local interest group",
                                value: "local-interest-group"
                            },
                            {
                                label: "Local resident",
                                value: "local-resident"
                            },
                            {
                                label: "Statutory body",
                                value: "statutory-body"
                            },
                            {
                                label: "Local business",
                                value: "local-business"
                            },
                            {
                                label: "Local representative",
                                value: "local-representative"
                            },
                            {
                                label: "Other (please specify)",
                                value: "other"
                            }
                        ],

                        additional_questions: [
                            {
                                label: "If other, please specify",
                                name: "25-progress-1",
                                type: "text",
                                number: "1"
                            }
                        ]
                    },
                    {
                        label: "Do you wish to be kept updated on the project?",
                        name: "25-progress",
                        required: true,
                        type: "radio",

                        options: [
                            {
                                label: "Yes",
                                value: "yes"
                            },
                            {
                                label: "No",
                                value: "no"
                            }
                        ],
                    },
                ]
            },
            {
                name: "Offshore elements",
                slug: "section-1",
                icon: "offshore",

                questions: [
                    {
                        label: `Do you have any comments / feedback on the offshore elements of the Project generally? You may choose to comment on the specific topics listed (see numbered topics 1.1 to 1.9 below).<br><br>
                        These topics are set out in detail in our Preliminary Environmental Information Report (PEIR) and more succinctly summarised in our PEIR Non-Technical Summary (both available to read in full at <a href="https://www.morecambeandmorgan.com/transmission">www.morecambeandmorgan.com/transmission</a>)`,
                        number: "1",
                        name: "01-question",
                        type: "text",

                        additional_questions: [
                            {
                                label: `Physical Processes (see <a target="_blank" href="https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Transmission+Assets+PEIR+Vol+2+Chapter+1.pdf">volume 2, chapter 1</a> of our PEIR)`,
                                name: "01-question-1",
                                type: "text",
                                number: "1"
                            },
                            {
                                label: `Benthic subtidal and intertidal ecology (see <a target="_blank" href="https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Transmission+Assets+PEIR+Vol+2+Chapter+2.pdf">volume 2, chapter 2</a> of our PEIR)`,
                                name: "01-question-2",
                                type: "text",
                                number: "2"
                            },
                            {
                                label: `Fish and shellfish ecology (see <a target="_blank" href="https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Transmission+Assets+PEIR+Vol+2+Chapter+3.pdf">volume 2, chapter 3</a> of our PEIR)`,
                                name: "01-question-3",
                                type: "text",
                                number: "3"
                            },
                            {
                                label: `Marine mammals (see <a target="_blank" href="https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Transmission+Assets+PEIR+Vol+2+Chapter+4.pdf">volume 2, chapter 4</a> of our PEIR)`,
                                name: "01-question-4",
                                type: "text",
                                number: "4"
                            },
                            {
                                label: `Offshore ornithology (see <a target="_blank" href="https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Transmission+Assets+PEIR+Vol+2+Chapter+5.pdf">volume 2, chapter 5</a> of our PEIR)`,
                                name: "01-question-5",
                                type: "text",
                                number: "5"
                            },
                            {
                                label: `Commercial fisheries (see <a target="_blank" href="https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Transmission+Assets+PEIR+Vol+2+Chapter+6.pdf">volume 2, chapter 6</a> of our PEIR)`,
                                name: "01-question-6",
                                type: "text",
                                number: "6"
                            },
                            {
                                label: `Shipping and navigation (see <a target="_blank" href="https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Transmission+Assets+PEIR+Vol+2+Chapter+7.pdf">volume 2, chapter 7</a> of our PEIR)`,
                                name: "01-question-7",
                                type: "text",
                                number: "7"
                            },
                            {
                                label: `Marine archaeology (see <a target="_blank" href="https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Transmission+Assets+PEIR+Vol+2+Chapter+8.pdf">volume 2, chapter 8</a> of our PEIR)`,
                                name: "01-question-8",
                                type: "text",
                                number: "8"
                            },
                            {
                                label: `Other sea users (see <a target="_blank" href="https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Transmission+Assets+PEIR+Vol+2+Chapter+9.pdf">volume 2, chapter 9</a> of our PEIR)`,
                                name: "01-question-9",
                                type: "text",
                                number: "9"
                            }
                        ]
                    }
                ]
            },
            {
                name: "Morgan offshore booster station",
                slug: "section-2",
                icon: "offshore_booster_station",

                questions: [
                    {
                        label: `Do you have any comments / feedback about the location of the Morgan offshore booster station search areas for the Project?<br><br>
                        See <a target="_blank" href="https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+1/Transmission+Assets+PEIR+Vol+1+Chapter+4.pdf">volume 1 of our PEIR, chapter 4: Site Selection and Consideration of Alternatives</a>.`,
                        number: "2",
                        name: "02-question",
                        type: "text"
                    }
                ]
            },
            {
                name: "Onshore elements",
                slug: "section-3",
                icon: "onshore",

                questions: [
                    {
                        label: `Do you have any comments or feedback on the onshore and / or intertidal elements of the Project generally? You may choose to comment on the specific topics listed (see numbered topics 3.1 to 3.9).<br /><br />
                        These topics are set out in detail in our Preliminary Environmental Information Report (PEIR) and more succinctly summarised in our PEIR Non-Technical Summary (both available to read in full at <a href="https://www.morecambeandmorgan.com/transmission">www.morecambeandmorgan.com/transmission</a>)`,
                        number: "3",
                        name: "03-question",
                        type: "text",

                        additional_questions: [
                            {
                                label: `Geology, hydrogeology and ground conditions (see <a target="_blank" href="https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Transmission+Assets+PEIR+Volume+3+Chapter+1.pdf">volume 3, chapter 1</a> of our PEIR)`,
                                name: "03-question-1",
                                type: "text",
                                number: "1"
                            },
                            {
                                label: `Hydrology and flood risk (see <a target="_blank" href="https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Transmission+Assets+PEIR+Volume+3+Chapter+2.pdf">volume 3, chapter 2</a> of our PEIR)`,
                                name: "03-question-2",
                                type: "text",
                                number: "2"
                            },
                            {
                                label: `Onshore ecology and nature conservation (see <a target="_blank" href="https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Transmission+Assets+PEIR+Volume+3+Chapter+3.pdf">volume 3, chapter 3<a/> of our PEIR)`,
                                name: "03-question-3",
                                type: "text",
                                number: "3"
                            },
                            {
                                label: `Onshore and intertidal ornithology (see <a target="_blank" href="https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Transmission+Assets+PEIR+Volume+3+Chapter+4.pdf">volume 3, chapter 4</a> of our PEIR)`,
                                name: "03-question-4",
                                type: "text",
                                number: "4"
                            },
                            {
                                label: `Historic environment (see <a target="_blank" href="https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Transmission+Assets+PEIR+Volume+3+Chapter+5.pdf">volume 3, chapter 5</a> of our PEIR)`,
                                name: "03-question-5",
                                type: "text",
                                number: "5"
                            },
                            {
                                label: `Land use and recreation (see <a target="_blank" href="https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Transmission+Assets+PEIR+Volume+3+Chapter+6.pdf">volume 3, chapter 6</a> of our PEIR)`,
                                name: "03-question-6",
                                type: "text",
                                number: "6"
                            },
                            {
                                label: `Traffic and transport (see <a target="_blank" href="https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Transmission+Assets+PEIR+Volume+3+Chapter+7.pdf">volume 3, chapter 7</a> of our PEIR)`,
                                name: "03-question-7",
                                type: "text",
                                number: "7"
                            },
                            {
                                label: `Noise and vibration (see <a target="_blank" href="https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Transmission+Assets+PEIR+Volume+3+Chapter+8.pdf">volume 3, chapter 8</a> of our PEIR)`,
                                name: "03-question-8",
                                type: "text",
                                number: "8"
                            },
                            {
                                label: `Air quality (see <a target="_blank" href="https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Transmission+Assets+PEIR+Volume+3+Chapter+9.pdf">volume 3, chapter 9</a> of our PEIR)`,
                                name: "03-question-9",
                                type: "text",
                                number: "9"
                            }
                        ]
                    }
                ]
            },
            {
                name: "General",
                slug: "section-4",
                icon: "uncategorised",

                questions: [
                    {
                        label: `Do you have any other comments or feedback on the Project to date generally, including the specific topics listed below (see numbered topics 4.1 to 4.5 below)?<br /><br />
                        These topics are set out in detail in our Preliminary Environmental Information Report (PEIR) and more succinctly summarised in our PEIR Non-Technical Summary (both available to read in full at <a href="https://www.morecambeandmorgan.com/transmission">www.morecambeandmorgan.com/transmission</a>)`,
                        number: "4",
                        name: "04-question",
                        type: "text",

                        additional_questions: [
                            {
                                label: `Seascape, landscape and visual resources (see <a target="_blank" href="https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+4/Transmission+Assets+PEIR+Vol+4+Chapter+1.pdf">volume 4, chapter 1</a> of our PEIR)`,
                                name: "04-question-1",
                                type: "text",
                                number: "1"
                            },
                            {
                                label: `Aviation and radar (see <a target="_blank" href="https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+4/Transmission+Assets+PEIR+Vol+4+Chapter+2.pdf">volume 4, chapter 2</a> of our PEIR)`,
                                name: "04-question-2",
                                type: "text",
                                number: "2"
                            },
                            {
                                label: `Climate change (see <a target="_blank" href="https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+4/Transmission+Assets+PEIR+Vol+4+Chapter+3.pdf">volume 4, chapter 3</a> of our PEIR)`,
                                name: "04-question-3",
                                type: "text",
                                number: "3"
                            },
                            {
                                label: `Socio-economics (see <a target="_blank" href="https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+4/Transmission+Assets+PEIR+Vol+4+Chapter+4.pdf">volume 4, chapter 4</a> of our PEIR)`,
                                name: "04-question-4",
                                type: "text",
                                number: "4"
                            },
                            {
                                label: `Inter relationships (see <a target="_blank" href="https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+4/Transmission+Assets+PEIR+Vol+4+Chapter+5.pdf">volume 4, chapter 5</a> of our PEIR)`,
                                name: "04-question-5",
                                type: "text",
                                number: "5"
                            }
                        ]
                    }
                ]
            },
            {
                name: "Location",
                slug: "section-5",
                icon: "location",

                questions: [
                    {
                        label: `Do you have any comments / feedback about the location of the Project landfall area? This is the area where the offshore export cables come onshore, and the transitional area between the offshore cabling and the onshore cabling, including transition joint bays.<br><br>
                        See <a target="_blank" href="https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+1/Transmission+Assets+PEIR+Vol+1+Chapter+4.pdf">volume 1 of our PEIR, chapter 4: Site Selection and Consideration of Alternatives</a>.`,
                        number: "5",
                        name: "05-question",
                        type: "text",
                    },
                    {
                        label: `Do you have any comments / feedback about the location of the proposed temporary compound areas and temporary and permanent access areas for the onshore and intertidal elements of the Project?<br><br>
                        See <a target="_blank" href="https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+1/Transmission+Assets+PEIR+Vol+1+Chapter+4.pdf">volume 1 of our PEIR, chapter 4: Site Selection and Consideration of Alternatives</a>.`,
                        number: "6",
                        name: "06-question",
                        type: "text",
                    },
                    {
                        label: `Do you have any comments / feedback about the location of the proposed Freckleton / Hall Cross onshore export cable corridor search area for the Project?<br><br>
                        See <a target="_blank" href="https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+1/Transmission+Assets+PEIR+Vol+1+Chapter+4.pdf">volume 1 of our PEIR, chapter 4: Site Selection and Consideration of Alternatives</a>.`,
                        number: "7",
                        name: "07-question",
                        type: "text",
                    },
                    {
                        label: `Do you have any comments / feedback about the proposed onshore substations statutory consultation area for the Project?<br><br>
                        See <a target="_blank" href="https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+1/Transmission+Assets+PEIR+Vol+1+Chapter+4.pdf">volume 1 of our PEIR, chapter 4: Site Selection and Consideration of Alternatives</a>.`,
                        number: "8",
                        name: "08-question",
                        type: "text",
                    }
                ]
            },
            {
                name: "Onshore substation",
                slug: "section-6",
                icon: "onshore_substation",

                questions: [
                    {
                        label: `Do you have any comments / feedback regarding the preferred onshore substation site for the Morgan Offshore Wind Project?<br><br>
                        See <a target="_blank" href="https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+1/Transmission+Assets+PEIR+Vol+1+Chapter+4.pdf">volume 1 of our PEIR, chapter 4: Site Selection and Consideration of Alternatives</a>.`,
                        number: "9",
                        name: "09-question",
                        type: "text",
                    },
                    {
                        label: `For our application the Morecambe Offshore Windfarm will be reducing to a single onshore substation site. Do you have any comments, feedback or preference regarding the two options presented for the Morecambe onshore substation site, and which one should be taken forward?<br><br>
                        See <a target="_blank" href="https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+1/Transmission+Assets+PEIR+Vol+1+Chapter+4.pdf">volume 1 of our PEIR, chapter 4: Site Selection and Consideration of Alternatives</a>.`,
                        number: "10",
                        name: "10-question",
                        type: "text",
                    }
                ]
            },
            {
                name: "Onshore topics",
                slug: "section-7",
                icon: "onshore_topics",

                questions: [
                    {
                        label: `Do you have any comments / feedback about the grid connection area for the Project?<br><br>
                        See <a target="_blank" href="https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+1/Transmission+Assets+PEIR+Vol+1+Chapter+4.pdf">volume 1 of our PEIR, chapter 4: Site Selection and Consideration of Alternatives</a>.`,
                        number: "11",
                        name: "11-question",
                        type: "text",
                    },
                    {
                        label: `Do you have any comments / feedback on how we propose to minimise the potential onshore impacts and effects? This might include your comments on our Outline Code of Construction Practice and its appendices.<br><br>
                        See <a target="_blank" href="https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+1/Transmission+Assets+PEIR+Vol+1+Chapter+3.pdf">volume 1 of our PEIR, chapter 3: Project Description</a>.`,
                        number: "12",
                        name: "12-question",
                        type: "text",
                    },
                    {
                        label: `Do you have any comments / feedback on the proposed Biodiversity Net Gain, enhancement and / or mitigation land areas for the Project?<br><br>
                        See <a target="_blank" href="https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+1/Transmission+Assets+PEIR+Vol+1+Chapter+3.pdf">volume 1 of our PEIR, chapter 3: Project Description</a>, and <a target="_blank" href="https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Transmission+Assets+PEIR+Volume+3+Chapter+3.pdf">volume 3 of our PEIR, chapter 3: Onshore Ecology and Nature Conservation</a>.`,
                        number: "13",
                        name: "13-question",
                        type: "text",
                    }
                ]
            },
            {
                name: "General",
                slug: "section-8",
                icon: "uncategorised",

                questions: [
                    {
                        label: "Do you have any comments / feedback on the draft Development Consent Order for the Project?",
                        number: "14",
                        name: "14-question",
                        type: "text",
                    },
                    {
                        label: "Do you have comments on how the Project could support and work with local communities?",
                        number: "15",
                        name: "15-question",
                        type: "text",
                    },
                    {
                        label: "Do you have any other comments / feedback on the Project, including any other information provided as a part of this consultation?",
                        number: "16",
                        name: "16-question",
                        type: "text",
                    }
                ]
            }
        ]
    },



	statConsultationMaterials: {
		peir: {
			title: "PEIR",

            introductionChapters: {
				index: 1,

				title: "PEIR Volume 1: Chapters",
				downloads: [
                    {
                        title: "Chapter 1: Introduction",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+1/Transmission+Assets+PEIR+Vol+1+Chapter+1.pdf",
                    },
                    {
                        title: "Chapter 2: Policy and legislation context",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+1/Transmission+Assets+PEIR+Vol+1+Chapter+2.pdf",
                    },
                    {
                        title: "Chapter 3: Project description",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+1/Transmission+Assets+PEIR+Vol+1+Chapter+3.pdf",
                    },
                    {
                        title: "Chapter 4: Site selection and consideration of alternatives",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+1/Transmission+Assets+PEIR+Vol+1+Chapter+4.pdf",
                    },
                    {
                        title: "Chapter 5: Environmental assessment methodology",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+1/Transmission+Assets+PEIR+Vol+1+Chapter+5.pdf",
                    }
				],
			},

            introductionAnnexes: {
				index: 2,

				title: "PEIR Volume 1: Annexes",
				downloads: [
                    {
                        title: "1.1 Statement of expertise",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+1/Volume+1+Annexes/Transmission+Assets+PEIR+Vol+1+Annex+1.1.pdf",
                    },
                    {
                        title: "3.1 Outline Code of Construction Practice",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+1/Volume+1+Annexes/Transmission+Assets+PEIR+Vol+1+Annex+3.1.pdf",
                    },
                    {
                        title: "5.1 Human health",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+1/Volume+1+Annexes/Transmission+Assets+PEIR+Vol+1+Annex+5.1.pdf",
                    },
                    {
                        title: "5.2 Underwater sound technical report",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+1/Volume+1+Annexes/Transmission+Assets+PEIR+Vol+1+Annex+5.2.pdf",
                    },
                    {
                        title: "5.3 Commitments register",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+1/Volume+1+Annexes/Transmission+Assets+PEIR+Vol+1+Annex+5.3.pdf",
                    },
                    {
                        title: "5.4 Transboundary screening",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+1/Volume+1+Annexes/Transmission+Assets+PEIR+Vol+1+Annex+5.4.pdf",
                    },
                    {
                        title: "5.5 Cumulative screening matrix and location plan",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+1/Volume+1+Annexes/Transmission+Assets+PEIR+Vol+1+Annex+5.5.pdf",
                    }
				],
			},

            introductionFigures: {
				index: 3,

				title: "PEIR Volume 1: Figures",
				downloads: [
                    {
                        title: "1.1 Transmission Assets Red Line Boundary",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+1/Volume+1+Figures/Transmission+Assets+PEIR+Vol+1+Figure+1.1+.pdf",
                    },
                    {
                        title: "3.1 Transmission Assets Red Line Boundary and Infrastructure Areas",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+1/Volume+1+Figures/Transmission+Assets+PEIR+Vol+1+Figure+3.1.pdf",
                    },
                    {
                        title: "3.2 Morgan offshore booster station search areas",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+1/Volume+1+Figures/Transmission+Assets+PEIR+Vol+1+Figure+3.2.pdf",
                    },
                    {
                        title: "3.3 Landfall location and arrangements",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+1/Volume+1+Figures/Transmission+Assets+PEIR+Vol+1+Figure+3.3.pdf",
                    },
                    {
                        title: "3.4 Onshore elements of the Transmission Assets",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+1/Volume+1+Figures/Transmission+Assets+PEIR+Vol+1+Figure+3.4.pdf",
                    },
                    {
                        title: "3.5 Cable installation in public highways between the landfall and Queensway (B5261)",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+1/Volume+1+Figures/Transmission+Assets+PEIR+Vol+1+Figure+3.5.pdf",
                    },
                    {
                        title: "3.6 Onshore substations",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+1/Volume+1+Figures/Transmission+Assets+PEIR+Vol+1+Figure+3.6+.pdf",
                    },
                    {
                        title: "3.7 Onshore biodiversity net gain, enhancement and/or mitigation areas",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+1/Volume+1+Figures/Transmission+Assets+PEIR+Vol+1+Figure+3.7.pdf",
                    },
                    {
                        title: "4.1 Landfall Area of Search",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+1/Volume+1+Figures/Transmission+Assets+PEIR+Vol+1+Figure+4.1.pdf",
                    },
                    {
                        title: "4.2 Ribble Estuary Constraints",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+1/Volume+1+Figures/Transmission+Assets+PEIR+Vol+1+Figure+4.2.pdf",
                    },
                    {
                        title: "4.3 Potential Landfall Zones",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+1/Volume+1+Figures/Transmission+Assets+PEIR+Vol+1+Figure+4.3.pdf",
                    },
                    {
                        title: "4.4 Lytham St Annes Landfall Zone",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+1/Volume+1+Figures/Transmission+Assets+PEIR+Vol+1+Figure+4.4.pdf",
                    },
                    {
                        title: "4.5 Banks Landfall Zone",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+1/Volume+1+Figures/Transmission+Assets+PEIR+Vol+1+Figure+4.5.pdf",
                    },
                    {
                        title: "4.6 Southport Landfall Zone",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+1/Volume+1+Figures/Transmission+Assets+PEIR+Vol+1+Figure+4.6.pdf",
                    },
                    {
                        title: "4.7 Ainsdale Landfall Zone",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+1/Volume+1+Figures/Transmission+Assets+PEIR+Vol+1+Figure+4.7.pdf",
                    },
                    {
                        title: "4.8 Formby Landfall Zone",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+1/Volume+1+Figures/Transmission+Assets+PEIR+Vol+1+Figure+4.8.pdf",
                    },
                    {
                        title: "4.9 South Formby Landfall Zone",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+1/Volume+1+Figures/Transmission+Assets+PEIR+Vol+1+Figure+4.9+.pdf",
                    },
                    {
                        title: "4.10 Preferred Landfall Zone at Lytham St Annes",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+1/Volume+1+Figures/Transmission+Assets+PEIR+Vol+1+Figure+4.10.pdf",
                    },
                    {
                        title: "4.11 Offshore Area of Search and Designations",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+1/Volume+1+Figures/Transmission+Assets+PEIR+Vol+1+FIgure+4.11.pdf",
                    },
                    {
                        title: "4.12 Offshore Area of Search and Existing Infrastructure (excluding Oil and Gas)",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+1/Volume+1+Figures/Transmission+Assets+PEIR+Vol+1+Figure+4.12.pdf",
                    },
                    {
                        title: "4.13 Offshore Area of Search and Oil and Gas Infrastructure",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+1/Volume+1+Figures/Transmission+Assets+PEIR+Vol+1+FIgure+4.13.pdf",
                    },
                    {
                        title: "4.14 Offshore Area of Search Scoping Boundary",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+1/Volume+1+Figures/Transmission+Assets+PEIR+Vol+1+Figure+4.14.pdf",
                    },
                    {
                        title: "4.15 Offshore Export Cable Routes",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+1/Volume+1+Figures/Transmission+Assets+PEIR+Vol+1+Figure+4.15.pdf",
                    },
                    {
                        title: "4.16 Offshore Export Cable Routes and Designations",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+1/Volume+1+Figures/Transmission+Assets+PEIR+Vol+1+Figure+4.16+.pdf",
                    },
                    {
                        title: "4.17 Offshore Export Cable Routes and Existing Infrastructure (excluding Oil and Gas)",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+1/Volume+1+Figures/Transmission+Assets+PEIR+Vol+1+Figure+4.17.pdf",
                    },
                    {
                        title: "4.18 Offshore Export Cable Routes and Oil and Gas Infrastructure",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+1/Volume+1+Figures/Transmission+Assets+PEIR+Vol+1+Figure+4.18.pdf",
                    },
                    {
                        title: "4.19 Morgan Offshore Booster Station Search Areas",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+1/Volume+1+Figures/Transmission+Assets+PEIR+Vol+1+Figure+4.19.pdf",
                    },
                    {
                        title: "4.20 Establishing Onshore Substation Scoping Boundary",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+1/Volume+1+Figures/Transmission+Assets+PEIR+Vol+1+Figure+4.20.pdf",
                    },
                    {
                        title: "4.21 Onshore Substation Scoping Boundary",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+1/Volume+1+Figures/Transmission+Assets+PEIR+Vol+1+Figure+4.21.pdf",
                    },
                    {
                        title: "4.22a Substation Zone Heat Mapping",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+1/Volume+1+Figures/Transmission+Assets+PEIR+Vol+1+Figure+4.22a.pdf",
                    },
                    {
                        title: "4.22b Substation Zone Heat Mapping",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+1/Volume+1+Figures/Transmission+Assets+PEIR+Vol+1+Figure+4.22b.pdf",
                    },
                    {
                        title: "4.23 Onshore Substation Site Selection Search",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+1/Volume+1+Figures/Transmission+Assets+PEIR+Vol+1+Figure+4.23.pdf",
                    },
                    {
                        title: "4.24 Onshore Substation Site Selection Search Constraints",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+1/Volume+1+Figures/Transmission+Assets+PEIR+Vol+1+Figure+4.24.pdf",
                    },
                    {
                        title: "4.25 Potential Substation Sites Zone 1",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+1/Volume+1+Figures/Transmission+Assets+PEIR+Vol+1+Figure+4.25.pdf",
                    },
                    {
                        title: "4.26 Onshore Cable Route Scoping Boundary",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+1/Volume+1+Figures/Transmission+Assets+PEIR+Vol+1+Figure+4.26.pdf",
                    },
                    {
                        title: "4.27 Onshore Cable Corridor Constraints",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+1/Volume+1+Figures/Transmission+Assets+PEIR+Vol+1+Figure+4.27.pdf",
                    },
                    {
                        title: "4.28 Onshore Cable Corridor",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+1/Volume+1+Figures/Transmission+Assets+PEIR+Vol+1+Figure+4.28.pdf",
                    }
				],
			},

            offshoreChapters: {
				index: 4,

				title: "PEIR Volume 2: Chapters",
				downloads: [
                    {
                        title: "Chapter 1: Physical Processes",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Transmission+Assets+PEIR+Vol+2+Chapter+1.pdf",
                    },
                    {
                        title: "Chapter 2: Benthic subtidal and intertidal ecology",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Transmission+Assets+PEIR+Vol+2+Chapter+2.pdf",
                    },
                    {
                        title: "Chapter 3: Fish and shellfish ecology",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Transmission+Assets+PEIR+Vol+2+Chapter+3.pdf",
                    },
                    {
                        title: "Chapter 4: Marine mammals",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Transmission+Assets+PEIR+Vol+2+Chapter+4.pdf",
                    },
                    {
                        title: "Chapter 5: Offshore ornithology ",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Transmission+Assets+PEIR+Vol+2+Chapter+5.pdf",
                    },
                    {
                        title: "Chapter 6: Commercial fisheries ",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Transmission+Assets+PEIR+Vol+2+Chapter+6.pdf",
                    },
                    {
                        title: "Chapter 7: Shipping and navigation ",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Transmission+Assets+PEIR+Vol+2+Chapter+7.pdf",
                    },
                    {
                        title: "Chapter 8: Marine archaeology ",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Transmission+Assets+PEIR+Vol+2+Chapter+8.pdf",
                    },
                    {
                        title: "Chapter 9: Other sea users",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Transmission+Assets+PEIR+Vol+2+Chapter+9.pdf",
                    }
				],
			},

            offshoreAnnex: {
				index: 5,

				title: "PEIR Volume 2: Annexes",
				downloads: [
                    {
                        title: "2.1 Benthic subtidal and intertidal ecology technical report",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Volume+2+Annexes/Transmission+Assets+PEIR+Volume+2+Annex+2.1.pdf",
                    },
                    {
                        title: "2.2 Water Framework Directive coastal waters assessment",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Volume+2+Annexes/Transmission+Assets+PEIR+Volume+2+Annex+2.2.pdf",
                    },
                    {
                        title: "3.1 Fish and shellfish ecology technical report",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Volume+2+Annexes/Transmission+Assets+PEIR+Volume+2+Annex+3.1.pdf",
                    },
                    {
                        title: "4.1 Marine mammals technical report",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Volume+2+Annexes/Transmission+Assets+PEIR+Volume+2+Annex+4.1.pdf",
                    },
                    {
                        title: "6.1 Commercial fisheries technical report",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Volume+2+Annexes/Transmission+Assets+PEIR+Volume+2+Annex+6.1.pdf",
                    },
                    {
                        title: "7.1 Navigation risk assessment",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Volume+2+Annexes/Transmission+Assets+PEIR+Volume+2+Annex+7.1.pdf",
                    },
                    {
                        title: "8.1 Marine archaeology technical report",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Volume+2+Annexes/Transmission+Assets+PEIR+Volume+2+Annex+8.1.pdf",
                    }
				],
			},

            offshoreFigures: {
				index: 6,

				title: "PEIR Volume 2: Figures",
				downloads: [
                    {
                        title: "1.1 Physical processes: study area",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Volume+2+Figures/Transmission+Assets+PEIR+Volume+2+Figure+1.1.pdf",
                    },
                    {
                        title: "1.2 Physical processes: designated areas",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Volume+2+Figures/Transmission+Assets+PEIR+Volume+2+Figure+1.2.pdf",
                    },
                    {
                        title: "1.3 Locations of site-specific and historic metocean data",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Volume+2+Figures/Transmission+Assets+PEIR+Volume+2+Figure+1.3.pdf",
                    },
                    {
                        title: "1.4 MBES illustrating dunes on Morgan South",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Volume+2+Figures/Transmission+Assets+PEIR+Volume+2+Figure+1.4.pdf",
                    },
                    {
                        title: "1.5 EMODnet and Gardline seabed substrate",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Volume+2+Figures/Transmission+Assets+PEIR+Volume+2+Figure+1.5.pdf",
                    },
                    {
                        title: "1.6 Physical processes: distribution of average non-algal SPM (Cefas)",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Volume+2+Figures/Transmission+Assets+PEIR+Volume+2+Figure+1.6.pdf",
                    },
                    {
                        title: "1.7 Physical processes: cumulative effect assessment – relavant projects",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Volume+2+Figures/Transmission+Assets+PEIR+Volume+2+Figure+1.7.pdf",
                    },
                    {
                        title: "2.1 Regional benthic subtidal and intertidal ecology study area",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Volume+2+Figures/Transmission+Assets+PEIR+Volume+2+Figure+2.1.pdf",
                    },
                    {
                        title: "2.2 Designated sites with benthic ecology features within the study area",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Volume+2+Figures/Transmission+Assets+PEIR+Volume+2+Figure+2.2.pdf",
                    },
                    {
                        title: "2.3 Folk sediment classifications for each benthic grab sample within the survey area",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Volume+2+Figures/Transmission+Assets+PEIR+Volume+2+Figure+2.3.pdf",
                    },
                    {
                        title: "2.4 Combined infaunal and epifaunal biotopes",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Volume+2+Figures/Transmission+Assets+PEIR+Volume+2+Figure+2.4.pdf",
                    },
                    {
                        title: "2.5 Landfall intertidal biotope map",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Volume+2+Figures/Transmission+Assets+PEIR+Volume+2+Figure+2.5.pdf",
                    },
                    {
                        title: "2.6 Cumulative assessment projects",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Volume+2+Figures/Transmission+Assets+PEIR+Volume+2+Figure+2.6.pdf",
                    },
                    {
                        title: "3.1 Transmission Assets fish and shellfish ecology study area",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Volume+2+Figures/Transmission+Assets+PEIR+Volume+2+Figure+3.1.pdf",
                        date: "Volume 2, Chapter 3 Figure titles 3.1-3.13 amendments made 12/10/2023 at 16.00, no change to data shown on figures.",
                    },
                    {
                        title: "3.2 Herring spawning habitat and site-specific survey data",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Volume+2+Figures/Transmission+Assets+PEIR+Volume+2+Figure+3.2.pdf",
                        date: "Volume 2, Chapter 3 Figure titles 3.1-3.13 amendments made 12/10/2023 at 16.00, no change to data shown on figures.",
                    },
                    {
                        title: "3.3 Herring spawning habitat and Generation Assets surveys data",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Volume+2+Figures/Transmission+Assets+PEIR+Volume+2+Figure+3.3.pdf",
                        date: "Volume 2, Chapter 3 Figure titles 3.1-3.13 amendments made 12/10/2023 at 16.00, no change to data shown on figures.",
                    },
                    {
                        title: "3.4 Sandeel habitat and site-specific survey data",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Volume+2+Figures/Transmission+Assets+PEIR+Volume+2+Figure+3.4.pdf",
                        date: "Volume 2, Chapter 3 Figure titles 3.1-3.13 amendments made 12/10/2023 at 16.00, no change to data shown on figures.",
                    },
                    {
                        title: "3.5 Sandeel habitat and Generation Assets surveys data",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Volume+2+Figures/Transmission+Assets+PEIR+Volume+2+Figure+3.5.pdf",
                        date: "Volume 2, Chapter 3 Figure titles 3.1-3.13 amendments made 12/10/2023 at 16.00, no change to data shown on figures.",
                    },
                    {
                        title: "3.6 Sandeel spawning and nursery grounds with subsea 10 dB noise SPLpk contours for monopile locations",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Volume+2+Figures/Transmission+Assets+PEIR+Volume+2+Figure+3.6.pdf",
                        date: "Volume 2, Chapter 3 Figure titles 3.1-3.13 amendments made 12/10/2023 at 16.00, no change to data shown on figures.",
                    },
                    {
                        title: "3.7 Sandeel spawning and nursery grounds with subsea 10 dB noise SPLpk contours for pin pile locations",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Transmission+Assets+PEIR+Volume+2+Figure+3.7.pdf",
                        date: "Volume 2, Chapter 3 Figure titles 3.1-3.13 amendments made 12/10/2023 at 16.00, no change to data shown on figures.",
                    },
                    {
                        title: "3.8 Cod spawning and nursery grounds with subsea 10 dB noise SPLpk contours for monopile locations",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Volume+2+Figures/Transmission+Assets+PEIR+Volume+2+Figure+3.8.pdf",
                        date: "Volume 2, Chapter 3 Figure titles 3.1-3.13 amendments made 12/10/2023 at 16.00, no change to data shown on figures.",
                    },
                    {
                        title: "3.9 Cod spawning and nursery grounds with subsea 10 dB noise SPLpk contours for pin pile locations",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Transmission+Assets+PEIR+Volume+2+Figure+3.9.pdf",
                        date: "Volume 2, Chapter 3 Figure titles 3.1-3.13 amendments made 12/10/2023 at 16.00, no change to data shown on figures.",
                    },
                    {
                        title: "3.10 Herring spawning and nursery grounds with subsea 10 dB noise SPLpk contours for monopile locations",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Volume+2+Figures/Transmission+Assets+PEIR+Volume+2+Figure+3.10.pdf",
                        date: "Volume 2, Chapter 3 Figure titles 3.1-3.13 amendments made 12/10/2023 at 16.00, no change to data shown on figures.",
                    },
                    {
                        title: "3.11 Herring spawning and nursery grounds with subsea 10 dB noise SPLpk contours for pin pile locations",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Transmission+Assets+PEIR+Volume+2+Figure+3.11.pdf",
                        date: "Volume 2, Chapter 3 Figure titles 3.1-3.13 amendments made 12/10/2023 at 16.00, no change to data shown on figures.",
                    },
                    {
                        title: "3.12 Herring spawning and nursery grounds with subsea 10 dB noise SEL single strike contours for monopile locations",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Volume+2+Figures/Transmission+Assets+PEIR+Volume+2+Figure+3.12.pdf",
                        date: "Volume 2, Chapter 3 Figure titles 3.1-3.13 amendments made 12/10/2023 at 16.00, no change to data shown on figures.",
                    },
                    {
                        title: "3.13 Herring spawning and nursery grounds with subsea 10 dB noise SEL single strike contours for pin pile locations",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Transmission+Assets+PEIR+Volume+2+Figure+3.13.pdf",
                        date: "Volume 2, Chapter 3 Figure titles 3.1-3.13 amendments made 12/10/2023 at 16.00, no change to data shown on figures.",
                    },
                    {
                        title: "3.14 Cumulative projects",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Volume+2+Figures/Transmission+Assets+PEIR+Volume+2+Figure+3.14.pdf",
                    },
                    {
                        title: "4.1 Marine mammal study areas and relevant species management units (MUS)",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Volume+2+Figures/Transmission+Assets+PEIR+Volume+2+Figure+4.1.pdf",
                    },
                    {
                        title: "4.2 Underwater sound level contours for Morgan OSP and Morecambe OSP concurrent piling single strike SEL",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Volume+2+Figures/Transmission+Assets+PEIR+Volume+2+Figure+4.2.pdf",
                    },
                    {
                        title: "4.3 Morgan and Morecambe Offshore Windfarms: Transmission Assets and Grey Seal at-sea Usage (Carter, et al., 2022), overlaid with selcum contours due to maximum hammer energy concurrent piling at Morgan OSP (5,500KJ) and Morecombe OSP (5,5000KJ)",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Volume+2+Figures/Transmission+Assets+PEIR+Volume+2+Figure+4.3.pdf",
                    },
                    {
                        title: "4.4 Morgan and Morecambe Offshore Windfarms: Transmission Assets and Harbour Seal at-sea Usage (Carter, et al., 2022), overlaid with selcum contours due to maximum hammer energy concurrent piling at Morgan OSP (5,500KJ) and Morecombe OSP (5,5000KJ)",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Volume+2+Figures/Transmission+Assets+PEIR+Volume+2+Figure+4.4.pdf",
                    },
                    {
                        title: "4.5 Cumulative projects screened in for Marine Mammals",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Volume+2+Figures/Transmission+Assets+PEIR+Volume+2+Figure+4.5.pdf",
                    },
                    {
                        title: "5.1 Study areas associated with impacts relevant to offshore ornithological receptors associated with the Transmission Assets",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Volume+2+Figures/Transmission+Assets+PEIR+Volume+2+Figure+5.1.pdf",
                    },
                    {
                        title: "5.2 SPAs and Ramsar sites of relevance to the Transmission Assets assessment",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Volume+2+Figures/Transmission+Assets+PEIR+Volume+2+Figure+5.2.pdf",
                    },
                    {
                        title: "5.3 Common scoter densities in the Liverpool Bay Area of Search (Lawson et al., 2016), with a 2 km buffer around Transmission Assets Red Line Boundary",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Volume+2+Figures/Transmission+Assets+PEIR+Volume+2+Figure+5.3.pdf",
                    },
                    {
                        title: "5.4 Red-throated diver densities in the Liverpool Bay Area of Search (Lawson et al., 2016), with a 2 km buffer around Transmission Assets Red Line Boundary",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Volume+2+Figures/Transmission+Assets+PEIR+Volume+2+Figure+5.4.pdf",
                    },
                    {
                        title: "5.5 Common scoter densities in the Liverpool Bay Area of Search (Lawson et al., 2016), with a 4 km buffer around OBS search areas",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Volume+2+Figures/Transmission+Assets+PEIR+Volume+2+Figure+5.5.pdf",
                    },
                    {
                        title: "5.6 Red-throated diver densities in the Liverpool Bay Area of Search (Lawson et al., 2016), with a 4 km buffer around OBS search areas",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Volume+2+Figures/Transmission+Assets+PEIR+Volume+2+Figure+5.6.pdf",
                    },
                    {
                        title: "5.7 Plans and projects considered in the cumulative effects assessment for the Transmission Assets",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Volume+2+Figures/Transmission+Assets+PEIR+Volume+2+Figure+5.7.pdf",
                    },
                    {
                        title: "6.1 Commercial fisheries study area",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Volume+2+Figures/Transmission+Assets+PEIR+Volume+2+Figure+6.1.pdf",
                    },
                    {
                        title: "6.2 Other projects, plans and activities screened into the cumulative effects assessment for commercial fisheries",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Volume+2+Figures/Transmission+Assets+PEIR+Volume+2+Figure+6.2.pdf",
                    },
                    {
                        title: "7.1 Shipping and navigation study area",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Volume+2+Figures/Transmission+Assets+PEIR+Volume+2+Figure+7.1.pdf",
                    },
                    {
                        title: "7.2 Offshore Activities",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Volume+2+Figures/Transmission+Assets+PEIR+Volume+2+Figure+7.2.pdf",
                    },
                    {
                        title: "7.3 Vessel traffic Survey",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Volume+2+Figures/Transmission+Assets+PEIR+Volume+2+Figure+7.3.pdf",
                    },
                    {
                        title: "7.4 Vessel traffic density",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Volume+2+Figures/Transmission+Assets+PEIR+Volume+2+Figure+7.4.pdf",
                    },
                    {
                        title: "7.5 Non-typical ferry routes",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Volume+2+Figures/Transmission+Assets+PEIR+Volume+2+Figure+7.5.pdf",
                    },
                    {
                        title: "7.6 Tier 1 Tier 2 windfarms",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Volume+2+Figures/Transmission+Assets+PEIR+Volume+2+Figure+7.6.pdf",
                    },
                    {
                        title: "8.1 Transmission Assets marine archaeology study area",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Volume+2+Figures/Transmission+Assets+PEIR+Volume+2+Figure+8.1.pdf",
                    },
                    {
                        title: "8.2 Transmission Assets survey area",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Volume+2+Figures/Transmission+Assets+PEIR+Volume+2+Figure+8.2.pdf",
                    },
                    {
                        title: "8.3 West Coast Palaeolandscape study area reconstruction of the Transmission Assets marine archaeology study area",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Volume+2+Figures/Transmission+Assets+PEIR+Volume+2+Figure+8.3.pdf",
                    },
                    {
                        title: "8.4 Geophysical anomalies within the study area",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Volume+2+Figures/Transmission+Assets+PEIR+Volume+2+Figure+8.4.pdf",
                    },
                    {
                        title: "8.5 Geophysical anomalies within thestudy area",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Volume+2+Figures/Transmission+Assets+PEIR+Volume+2+Figure+8.5.pdf",
                    },
                    {
                        title: "8.6 Geophysical anomalies within the Morecambe Offshore Windfarm: Generation Assets marine archaeology study area",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Volume+2+Figures/Transmission+Assets+PEIR+Volume+2+Figure+8.6.pdf",
                    },
                    {
                        title: "8.7 Marine archaeology identifed within the desktop study area",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Volume+2+Figures/Transmission+Assets+PEIR+Volume+2+Figure+8.7.pdf",
                    },
                    {
                        title: "8.8 Proposed AEZs and TAEZs within the Transmission Assets marine archaeology study area",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Volume+2+Figures/Transmission+Assets+PEIR+Volume+2+Figure+8.8.pdf",
                    },
                    {
                        title: "8.9 Other projects, plans and activities screened into the cumulative effects",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Volume+2+Figures/Transmission+Assets+PEIR+Volume+2+Figure+8.9.pdf",
                    },
                    {
                        title: "9.1 The Transmission Assets other sea users study areas",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Volume+2+Figures/Transmission+Assets+PEIR+Volume+2+Figure+9.1.pdf",
                    },
                    {
                        title: "9.2 Disposal and aggregate extraction sites in the vicinity of the Transmission Assets",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Volume+2+Figures/Transmission+Assets+PEIR+Volume+2+Figure+9.2.pdf",
                    },
                    {
                        title: "9.3 Recreational activities in the vicinity of the Transmission Assets",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Volume+2+Figures/Transmission+Assets+PEIR+Volume+2+Figure+9.3.pdf",
                    },
                    {
                        title: "9.4 Offshore wind farms and cable routes in the vicinity of the Transmission Assets",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Volume+2+Figures/Transmission+Assets+PEIR+Volume+2+Figure+9.4.pdf",
                    },
                    {
                        title: "9.5 Oil and gas licence blocks in the vicinity of the Transmission Assets",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Volume+2+Figures/Transmission+Assets+PEIR+Volume+2+Figure+9.5.pdf",
                    },
                    {
                        title: "9.6 CCS and oil and gas activiites in the vicinity of the Transmission Assets",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Volume+2+Figures/Transmission+Assets+PEIR+Volume+2+Figure+9.6.pdf",
                    },
                    {
                        title: "9.7 Other projects, plans and activities screened into the CEA",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+2/Volume+2+Figures/Transmission+Assets+PEIR+Volume+2+Figure+9.7.pdf",
                    }
				],
			},

            onshoreChapters: {
				index: 7,

				title: "PEIR Volume 3: Chapters",
				downloads: [
                    {
                        title: "Chapter 1: Geology, hydrogeology and ground conditions",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Transmission+Assets+PEIR+Volume+3+Chapter+1.pdf",
                    },
                    {
                        title: "Chapter 2: Hydrology and flood risk",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Transmission+Assets+PEIR+Volume+3+Chapter+2.pdf",
                    },
                    {
                        title: "Chapter 3: Onshore ecology and nature conservation",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Transmission+Assets+PEIR+Volume+3+Chapter+3.pdf",
                    },
                    {
                        title: "Chapter 4: Onshore and intertidal ornithology",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Transmission+Assets+PEIR+Volume+3+Chapter+4.pdf",
                    },
                    {
                        title: "Chapter 5: Historic environment",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Transmission+Assets+PEIR+Volume+3+Chapter+5.pdf",
                    },
                    {
                        title: "Chapter 6: Land use and recreation",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Transmission+Assets+PEIR+Volume+3+Chapter+6.pdf",
                    },
                    {
                        title: "Chapter 7: Traffic and transport",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Transmission+Assets+PEIR+Volume+3+Chapter+7.pdf",
                    },
                    {
                        title: "Chapter 8: Noise and vibration",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Transmission+Assets+PEIR+Volume+3+Chapter+8.pdf",
                    },
                    {
                        title: "Chapter 9: Air quality",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Transmission+Assets+PEIR+Volume+3+Chapter+9.pdf",
                    }
				],
			},

            onshoreAnnex: {
				index: 8,

				title: "PEIR Volume 3: Annexes",
				downloads: [
                    {
                        title: "1.1 Geology, hydrogeology and ground conditions technical report",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Annexes/Transmission+Assets+PEIR+Vol+3+Annex+1.1.pdf",
                    },
                    {
                        title: "2.1 Water Framework Directive surface water and groundwater assessment",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Annexes/Transmission+Assets+PEIR+Vol+3+Annex+2.1.pdf",
                    },
                    {
                        title: "2.2 Surface water abstraction licences, discharge consents and pollution incidents",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Annexes/Transmission+Assets+PEIR+Vol+3+Annex+2.2.pdf",
                    },
                    {
                        title: "2.3 Flood risk assessment",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Annexes/Transmission+Assets+PEIR+Vol+3+Annex+2.3.pdf",
                    },
                    {
                        title: "3.1 Onshore ecology desk study",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Annexes/Transmission+Assets+PEIR+Vol+3+Annex+3.1.pdf",
                    },
                    {
                        title: "3.2 Interim phase 1 habitat survey technical report",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Annexes/Transmission+Assets+PEIR+Vol+3+Annex+3.2.pdf",
                    },
                    {
                        title: "3.3 Interim badger technical report (confidential)",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Annexes/Transmission+Assets+PEIR+Vol+3+Annex+3.3.pdf",
                    },
                    {
                        title: "3.4 Interim bat technical report",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Annexes/Transmission+Assets+PEIR+Vol+3+Annex+3.4.pdf",
                    },
                    {
                        title: "3.5 Great crested newt technical report",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Annexes/Transmission+Assets+PEIR+Vol+3+Annex+3.5.pdf",
                    },
                    {
                        title: "3.6 Interim otter technical report (confidential)",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Annexes/Transmission+Assets+PEIR+Vol+3+Annex+3.6.pdf",
                    },
                    {
                        title: "3.7 Interim water vole technical report",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Annexes/Transmission+Assets+PEIR+Vol+3+Annex+3.7.pdf",
                    },
                    {
                        title: "3.8 White-clawed crayfish technical report",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Annexes/Transmission+Assets+PEIR+Vol+3+Annex+3.8.pdf",
                    },
                    {
                        title: "3.9 Onshore ecology and nature conservation survey methodologies",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Annexes/Transmission+Assets+PEIR+Vol+3+Annex+3.9.pdf",
                    },
                    {
                        title: "4.1 Onshore and intertidal ornithology - Breeding birds survey report",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Annexes/Transmission+Assets+PEIR+Vol+3+Annex+4.1.pdf",
                    },
                    {
                        title: "4.2 Onshore and intertidal ornithology - Wintering and migratory birds technical report",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Annexes/Transmission+Assets+PEIR+Vol+3+Annex+4.2.pdf",
                    },
                    {
                        title: "4.3 Onshore and intertidal ornithology - Intertidal birds technical report",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Annexes/Transmission+Assets+PEIR+Vol+3+Annex+4.3.pdf",
                    },
                    {
                        title: "4.4 Ornithological survey methodologies",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Annexes/Transmission+Assets+PEIR+Vol+3+Annex+4.4.pdf",
                    },
                    {
                        title: "5.1 Historic environment desk-based assessment",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Annexes/Transmission+Assets+PEIR+Vol+3+Annex+5.1.pdf",
                    },
                    {
                        title: "5.2 Onshore archaeological geophysical survey report",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Annexes/Transmission+Assets+PEIR+Vol+3+Annex+5.2.pdf",
                    },
                    {
                        title: "5.3 Intertidal archaeological survey report",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Annexes/Transmission+Assets+PEIR+Vol+3+Annex+5.3.pdf",
                    },
                    {
                        title: "5.4 Geoarchaeological desk-based assessment report",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Annexes/Transmission+Assets+PEIR+Vol+3+Annex+5.4.pdf",
                    },
                    {
                        title: "6.1 Published agricultural land classification and soils data",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Annexes/Transmission+Assets+PEIR+Vol+3+Annex+6.1.pdf",
                    },
                    {
                        title: "7.1 Description of network links and sensitivity",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Annexes/Transmission+Assets+PEIR+Vol+3+Annex+7.1.pdf",
                    },
                    {
                        title: "7.2 Potential accesses",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Annexes/Transmission+Assets+PEIR+Vol+3+Annex+7.2.pdf",
                    },
                    {
                        title: "8.1 Baseline sound survey",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Annexes/Transmission+Assets+PEIR+Vol+3+Annex+8.1.pdf",
                    },
                    {
                        title: "8.2 Construction noise and vibration",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Annexes/Transmission+Assets+PEIR+Vol+3+Annex+8.2.pdf",
                    },
                    {
                        title: "8.3 Operational noise",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Annexes/Transmission+Assets+PEIR+Vol+3+Annex+8.3.pdf",
                    }
				],
			},

            onshoreFigures: {
				index: 9,

				title: "PEIR Volume 3: Figures",
				downloads: [
                    {
                        title: "1.1 Geology, hydrogeology and ground conditions study area",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Figures/Transmission+Assets+PEIR+Vol+3+Figure+1.1.pdf",
                    },
                    {
                        title: "2.1 Transmission Assets hydrology and flood risk study area",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Figures/Transmission+Assets+PEIR+Vol+3+Figure+2.1.pdf",
                    },
                    {
                        title: "2.2 Watercourses and flood zones within the study area",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Figures/Transmission+Assets+PEIR+Vol+3+Figure+2.2.pdf",
                    },
                    {
                        title: "2.3 WFD catchments within the study area",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Figures/Transmission+Assets+PEIR+Vol+3+Figure+2.3.pdf",
                    },
                    {
                        title: "2.4 Flood warnings and flood alerts within the study area",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Figures/Transmission+Assets+PEIR+Vol+3+Figure+2.4.pdf",
                    },
                    {
                        title: "2.5 Bedrock geology within the study area",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Figures/Transmission+Assets+PEIR+Vol+3+Figure+2.5.pdf",
                    },
                    {
                        title: "2.6 Superficial deposits within the study area",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Figures/Transmission+Assets+PEIR+Vol+3+Figure+2.6.pdf",
                    },
                    {
                        title: "2.7 Source Protection Zone within the study area",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Figures/Transmission+Assets+PEIR+Vol+3+Figure+2.7.pdf",
                    },
                    {
                        title: "2.8 Designated sites within the study area",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Figures/Transmission+Assets+PEIR+Vol+3+Figure+2.8.pdf",
                    },
                    {
                        title: "3.1 Onshore ecology study area",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Figures/Transmission+Assets+PEIR+Vol+3+Figure+3.1.pdf",
                    },
                    {
                        title: "3.2 Onshore ecology survey area",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Figures/Transmission+Assets+PEIR+Vol+3+Figure+3.2.pdf",
                    },
                    {
                        title: "3.3 Phase 1 habitat survey area sections",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Figures/Transmission+Assets+PEIR+Vol+3+Figure+3.3.pdf",
                    },
                    {
                        title: "3.4 Phase 1 habitat surveys completed and reported in the PEIR",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Figures/Transmission+Assets+PEIR+Vol+3+Figure+3.4.pdf",
                    },
                    {
                        title: "4.1 Onshore and intertidal ornithology study area and designations",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Figures/Transmission+Assets+PEIR+Vol+3+Figure+4.1.pdf",
                    },
                    {
                        title: "4.2 Onshore survey area",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Figures/Transmission+Assets+PEIR+Vol+3+Figure+4.2.pdf",
                    },
                    {
                        title: "4.3 Coastal intertidal survey area",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Figures/Transmission+Assets+PEIR+Vol+3+Figure+4.3.pdf",
                    },
                    {
                        title: "4.4 Estuarine intertidal survey area",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Figures/Transmission+Assets+PEIR+Vol+3+Figure+4.4.pdf",
                    },
                    {
                        title: "4.5 Habitat types present within the survey area",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Figures/Transmission+Assets+PEIR+Vol+3+Figure+4.5.pdf",
                    },
                    {
                        title: "5.1 Site location",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Figures/Transmission+Assets+PEIR+Vol+3+Figure+5.1.pdf",
                    },
                    {
                        title: "5.2 Location of Morgan offshore booster station search areas and designated heritage assets",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Figures/Transmission+Assets+PEIR+Vol+3+Figure+5.2.pdf",
                    },
                    {
                        title: "5.3a Designated heritage assets within the 1 km settings study area – Plot A",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Figures/Transmission+Assets+PEIR+Vol+3+Figure+5.3a.pdf",
                    },
                    {
                        title: "5.3b Designated heritage assets within the 1 km settings study area – Plot B",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Figures/Transmission+Assets+PEIR+Vol+3+Figure+5.3b.pdf",
                    },
                    {
                        title: "5.3c Designated heritage assets within the 1 km settings study area – Plot C",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Figures/Transmission+Assets+PEIR+Vol+3+Figure+5.3c.pdf",
                    },
                    {
                        title: "5.3d Designated heritage assets within the 1 km settings study area – Plot D",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Figures/Transmission+Assets+PEIR+Vol+3+Figure+5.3d.pdf",
                    },
                    {
                        title: "5.4 Designated heritage assets within the 5 km settings study area",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Figures/Transmission+Assets+PEIR+Vol+3+Figure+5.4.pdf",
                    },
                    {
                        title: "5.5a Non-designated heritage assets within the 500m historic environment study area – Plot A",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Figures/Transmission+Assets+PEIR+Vol+3+Figure+5.5a.pdf",
                    },
                    {
                        title: "5.5b Non-designated heritage assets within the 500m historic environment study area – Plot B",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Figures/Transmission+Assets+PEIR+Vol+3+Figure+5.5b.pdf",
                    },
                    {
                        title: "5.5c Non-designated heritage assets within the 500m historic environment study area – Plot C",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Figures/Transmission+Assets+PEIR+Vol+3+Figure+5.5c.pdf",
                    },
                    {
                        title: "6.1a Land use study area",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Figures/Transmission+Assets+PEIR+Vol+3+Figure+6.1a.pdf",
                    },
                    {
                        title: "6.1b Recreation study area",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Figures/Transmission+Assets+PEIR+Vol+3+Figure+6.1b.pdf",
                    },
                    {
                        title: "6.2 Public rights of way",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Figures/Transmission+Assets+PEIR+Vol+3+Figure+6.2.pdf",
                    },
                    {
                        title: "6.3 Recreational resources",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Figures/Transmission+Assets+PEIR+Vol+3+Figure+6.3.pdf",
                    },
                    {
                        title: "6.4 Published soil survey mapping",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Figures/Transmission+Assets+PEIR+Vol+3+Figure+6.4.pdf",
                    },
                    {
                        title: "6.5 Provisional Agricultural Land Classification mapping",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Figures/Transmission+Assets+PEIR+Vol+3+Figure+6.5.pdf",
                    },
                    {
                        title: "6.6 Detailed Defra Agricultural Land Classification mapping",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Figures/Transmission+Assets+PEIR+Vol+3+Figure+6.6.pdf",
                    },
                    {
                        title: "7.1 Highway network overview",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Figures/Transmission+Assets+PEIR+Vol+3+Figure+7.1.pdf",
                    },
                    {
                        title: "7.2 Public transport network",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Figures/Transmission+Assets+PEIR+Vol+3+Figure+7.2.pdf",
                    },
                    {
                        title: "7.3 Sensitive receptors",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Figures/Transmission+Assets+PEIR+Vol+3+Figure+7.3.pdf",
                    },
                    {
                        title: "8.1 Offshore piling noise study area",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Figures/Transmission+Assets+PEIR+Vol+3+Figure+8.1.pdf",
                    },
                    {
                        title: "8.2 Construction noise study area (landfall)",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Figures/Transmission+Assets+PEIR+Vol+3+Figure+8.2.pdf",
                    },
                    {
                        title: "8.3 Construction noise study area (onshore export cable corridor and 400 kV grid connection cable corridor)",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Figures/Transmission+Assets+PEIR+Vol+3+Figure+8.3.pdf",
                    },
                    {
                        title: "8.4 Operational noise study area",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Figures/Transmission+Assets+PEIR+Vol+3+Figure+8.4.pdf",
                    },
                    {
                        title: "8.5 Construction vibration study area (onshore export cable corridor and 400 kV grid connection cable corridor)",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Figures/Transmission+Assets+PEIR+Vol+3+Figure+8.5.pdf",
                    },
                    {
                        title: "8.6 Developments included in the cumulative effects assessment",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Figures/Transmission+Assets+PEIR+Vol+3+Figure+8.6.pdf",
                    },
                    {
                        title: "9.1 Construction dust assessment buffers",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+3/Volume+3+Figures/Transmission+Assets+PEIR+Vol+3+Figure+9.1.pdf",
                    }
				],
			},

            visualChapters: {
				index: 10,

				title: "PEIR Volume 4: Chapters",
				downloads: [
                    {
                        title: "Chapter 1: Seascape, landscape and visual resources",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+4/Transmission+Assets+PEIR+Vol+4+Chapter+1.pdf",
                    },
                    {
                        title: "Chapter 2: Aviation and radar",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+4/Transmission+Assets+PEIR+Vol+4+Chapter+2.pdf",
                    },
                    {
                        title: "Chapter 3: Climate change",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+4/Transmission+Assets+PEIR+Vol+4+Chapter+3.pdf",
                    },
                    {
                        title: "Chapter 4: Socio-economics",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+4/Transmission+Assets+PEIR+Vol+4+Chapter+4.pdf",
                    },
                    {
                        title: "Chapter 5: Inter-relationships",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+4/Transmission+Assets+PEIR+Vol+4+Chapter+5.pdf",
                    }
				],
			},

            visualAnnex: {
				index: 11,

				title: "PEIR Volume 4: Annexes",
				downloads: [
                    {
                        title: "1.1 Seascape, landscape and visual resources planning policy context",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+4/Volume+4+Annexes/Transmission+Assets+PEIR+Vol+4+Annex+1.1.pdf",
                    },
                    {
                        title: "1.2 Seascape and landscape character baseline technical report",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+4/Volume+4+Annexes/Transmission+Assets+PEIR+Vol+4+Annex+1.2.pdf",
                    },
                    {
                        title: "1.3 Visual baseline technical report",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+4/Volume+4+Annexes/Transmission+Assets+PEIR+Vol+4+Annex+1.3.pdf",
                    },
                    {
                        title: "1.4 Seascape, landscape and visual resources impact assessment methodology",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+4/Volume+4+Annexes/Transmission+Assets+PEIR+Vol+4+Annex+1.4.pdf",
                    },
                    {
                        title: "3.1 Greenhouse gas assessment",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+4/Volume+4+Annexes/Transmission+Assets+PEIR+Vol+4+Annex+3.1.pdf",
                    },
                    {
                        title: "3.2 Climate change risk assessment",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+4/Volume+4+Annexes/Transmission+Assets+PEIR+Vol+4+Annex+3.2.pdf",
                    },
                    {
                        title: "4.1 Technical impact report - socio-economics",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+4/Volume+4+Annexes/Transmission+Assets+PEIR+Vol+4+Annex+4.1.pdf",
                    }
				],
			},

            visualFigures: {
				index: 12,

				title: "PEIR Volume 4: Figures",
				downloads: [
                    {
                        title: "1.1 Seascape, landscape and visual resources study area",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+4/Volume+4+Figures/Transmission+Assets+PEIR+Vol+4+Figure+1.1.pdf",
                    },
                    {
                        title: "1.2 Preliminary ZTV with representative viewpoint locations – Scenario 1: Morgan substation site and Morecambe substation site option 1 (north) with local landscape character areas",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+4/Volume+4+Figures/Transmission+Assets+PEIR+Vol+4+Figure+1.2.pdf",
                    },
                    {
                        title: "1.3 Preliminary ZTV with representative viewpoint locations – Scenario 2: Morgan substation site and Morecambe substation site option 2 (south) with local landscape character areas",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+4/Volume+4+Figures/Transmission+Assets+PEIR+Vol+4+Figure+1.3.pdf",
                    },
                    {
                        title: "1.4 Onshore designations and context",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+4/Volume+4+Figures/Transmission+Assets+PEIR+Vol+4+Figure+1.4.pdf",
                    },
                    {
                        title: "1.5 Landscape context and designations Scenario 1: Morgan substation site and Morecambe substation site option 1 (north)",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+4/Volume+4+Figures/Transmission+Assets+PEIR+Vol+4+Figure+1.5.pdf",
                    },
                    {
                        title: "1.6 Landscape context and designations Scenario 2: Morgan substation site and Morecambe substation site option 2 (south)",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+4/Volume+4+Figures/Transmission+Assets+PEIR+Vol+4+Figure+1.6.pdf",
                    },
                    {
                        title: "1.7 Offshore wirelines and onshore substation photo wirelines",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+4/Volume+4+Figures/Transmission+Assets+PEIR+Vol+4+Figure+1.7.pdf",
                    },
                    {
                        title: "1.8 Offshore elements of the Transmission Assets and existing and proposed offshore and onshore wind projects",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+4/Volume+4+Figures/Transmission+Assets+PEIR+Vol+4+Figure+1.8.pdf",
                    },
                    {
                        title: "1.9 Onshore elements of the Transmission Assets and proposed onshore CEA developments",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+4/Volume+4+Figures/Transmission+Assets+PEIR+Vol+4+Figure+1.9.pdf",
                    },
                    {
                        title: "1.10 Offshore elements of the Transmission Assets and offshore windfarm cumulative ZTVs",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+4/Volume+4+Figures/Transmission+Assets+PEIR+Vol+4+Figure+1.10.pdf",
                    },
                    {
                        title: "1.11 Offshore elements of the Transmission Assets and onshore windfarm cumulative ZTVs",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+4/Volume+4+Figures/Transmission+Assets+PEIR+Vol+4+Figure+1.11.pdf",
                    },
                    {
                        title: "1.12 Offshore elements of the Transmission Assets cumulative wirelines",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+4/Volume+4+Figures/Transmission+Assets+PEIR+Vol+4+Figure+1.12.pdf",
                    },
                    {
                        title: "2.1 Aviation features in the vicinity of the aviation and radar study area for the Transmission Assets",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+4/Volume+4+Figures/Transmission+Assets+PEIR+Vol+4+Figure+2.1.pdf",
                    },
                    {
                        title: "2.2 Cumulative aviation and radar study area",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+4/Volume+4+Figures/Transmission+Assets+PEIR+Vol+4+Figure+2.2.pdf",
                    },
                    {
                        title: "3.1 Transmission Assets Red Line Boundary",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+4/Volume+4+Figures/Transmission+Assets+PEIR+Vol+4+Figure+3.1.pdf",
                    },
                    {
                        title: "4.1 Socio-economics (offshore) regional study area for the proposed development",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+4/Volume+4+Figures/Transmission+Assets+PEIR+Vol+4+Figure+4.1.pdf",
                    },
                    {
                        title: "4.2 Socio-economics (onshore) sub-regional study area for the proposed development",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Volume+4/Volume+4+Figures/Transmission+Assets+PEIR+Vol+4+Figure+4.2.pdf",
                    }
				],
			},


            nts: {
				index: 13,

				title: "PEIR Non-Technical Summary",
				downloads: [
                    {
                        title: "Non-Technical Summary",
                        url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Transmission+Assets+PEIR+Non-Technical+Summary.pdf",
                    }
				],
			},
		},

		otherDocs: {
			index: 14,

			title: "Other documents",
			downloads: [
                {
                    title: "HRA Stage 1 Screening Report",
                    url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Other+documents/Transmission+Assets+HRA+Screening.pdf",
                },
                {
                    title: "Habitats Regulations Assessment Stage 2 Information to Support an Appropriate Assessment",
                    url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Other+documents/Transmission+Assets+ISAA.pdf",
                },
                {
                    title: "Marine Conservation Zone (MCZ) Screening and Stage 1 Assessment Report",
                    url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Other+documents/Transmission+Assets+MCZ+Assessment.pdf",
                }
			]
		},

        plansDrawings: {
			index: 15,

			title: "Plans and drawings",
			downloads: [
                {
                    title: "Indicative Extent of Marine Licences",
                    url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Plans+and+drawings/Indicative+Extent+of+Marine+Licences.pdf",
                },
                {
                    title: "Location plan(s) (Onshore and offshore)",
                    url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Plans+and+drawings/Location+Plan(s)+(Onshore+and+Offshore).pdf",
                },
                {
                    title: "Works Plans - Onshore and Offshore",
                    url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Plans+and+drawings/Works+Plans+-+Onshore+and+Offshore.pdf",
                }
			]
		},

        draftDco: {
			index: 16,

			title: "Draft DCO",
			downloads: [
                {
                    title: "Draft Development Consent Order incl. Draft Deemed Marine licences",
                    url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Draft+DCO/Draft+Development+Consent+Order+incl.+Draft+Deemed+Marine+Licences.pdf",
                },
                {
                    title: "Draft Development Consent Order: Explanatory Note",
                    url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/PEIR/Draft+DCO/Draft+Development+Consent+Order_Explanatory+Note.pdf",
                }
			]
		},

		consultation: {
			index: 17,

			title: "Statutory consultation information",
			downloads: [
                {
                    title: "Statement of Community Consultation (SoCC)",
                    url: "/assets/images/transmission/pdf/M&M-TRANSMISSION-SoCC-pages.pdf",
                },
                {
                    title: "Consultation Brochure (Single pages)",
                    url: "/assets/images/transmission/pdf/M&M-TRANSMISSION-Brochure_pages.pdf",
                },
                {
                    title: "Consultation Brochure (Spread pages)",
                    url: "/assets/images/transmission/pdf/M&M-TRANSMISSION-Brochure_spreads.pdf",
                },
                {
                    title: "Deposit Locations",
                    url: "/assets/images/transmission/pdf/M&M-TRANSMISSION-Deposit-locations.pdf",
                },
                {
                    title: "Feedback Form",
                    url: "/assets/images/transmission/pdf/M&M-TRANSMISSION-Feedback-Form_pages.pdf",
                },
                {
                    title: "Consultation Poster",
                    url: "/assets/images/transmission/pdf/M&M-TRANSMISSION-Poster.pdf",
                },
                {
                    title: "Consultation Newsletter (Single pages)",
                    url: "/assets/images/transmission/pdf/M&M-TRANSMISSION-Newsletter_pages.pdf",
                },
                {
                    title: "Consultation Newsletter (Spread pages)",
                    url: "/assets/images/transmission/pdf/M&M-TRANSMISSION-Newsletter_spreads.pdf",
                },
                {
                    title: "Section 42 Notice",
                    url: "/assets/images/transmission/pdf/TransmissionAssets-S42.pdf",
                },
                {
                    title: "Section 47 Notice",
                    url: "/assets/images/transmission/pdf/TransmissionAssets-S47.pdf",
                },
                {
                    title: "Section 48 Notice",
                    url: "/assets/images/transmission/pdf/TransmissionAssets-S48.pdf",
                },
                {
                    title: "Morgan and Morecambe Offshore Wind Farms: Transmission Assets project - Map",
                    url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/Morgan+and+Morecambe+Offshore+Wind+Farms+Transmission+Assets+project+-+Map.pdf",
                },
                {
                    title: "Recording of online consultation event 6 Nov 2023",
                    videoId: "882824529",
                    type: "video",
                }
			]
		},
    },

    examination: {
		examination: {
			index: 18,

			title: "Examination",
			downloads: [
                {
                    title: "Notice of Open Floor Hearing - July 2025",
                    url: "/assets/images/shared/downloads/transmission/Hearing_Notice_July_2025.pdf",
                },
                {
                    title: "Location plan of the proposed development (Hearing notice) - July 2025",
                    url: "/assets/images/shared/downloads/transmission/Hearing_Notice_Location_July_2025.pdf",
                },
                {
                    title: "Notice of Open Floor Hearing - June 2025",
                    url: "/assets/images/shared/downloads/transmission/MMTA_Hearing_Notice_24June25.pdf",
                },
                {
                    title: "Location plan of the proposed development (Hearing notice) - June 2025",
                    url: "/assets/images/shared/downloads/transmission/M3_MR_PRJ_0001_Rev02_Onshore_HEARINGNOTICE.pdf",
                },
                {
                    title: "Notice of Preliminary Hearing - April 2025",
                    url: "/assets/images/transmission/pdf/MMTA_Hearing_Notice(Apr25)_Rev01.pdf",
                },
                {
                    title: "Location plan of the proposed development (Hearing notice) - April 2025",
                    url: "/assets/images/transmission/pdf/MMTA_April_Hearing_Notice_Plan.pdf",
                }
			]
		},
    },

    acceptance: [
        {
            title: "Morgan and Morecambe Offshore Wind Farms: Transmission Assets - Section 56 Planning Act 2008",
            url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/MMTA+Section+56+Planning+Act+2008_Final+for+issue+(1).pdf",
        }
    ],

    postSubmission: [
        {
            title: "Morgan and Morecambe Offshore Wind Farms: Transmission Assets – Project update - Autumn 2024",
            url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/13822-M%26M-TRANS+Newsletter-8+page-FINAL+LR.pdf",
        }
    ],

    preSubmission: [
        {
            title: "Morgan and Morecambe Offshore Wind Farms: Transmission Assets – Next Steps",
            url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/Community+update+sent+2509241-compressed.pdf",
        },
        {
            title: "Upcoming surveys - Morgan and Morecambe Offshore Wind Farms: Transmission Assets",
            url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/Occupier+Leaflet+Letter.pdf"
        },
        {
            title: "Upcoming surveys – Blackpool Road Recreation ",
            url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/GI+works+letter+Sep+2024.pdf"
        },
        {
            title: "Nighttime surveys at Blackpool Airport",
            url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/Blackpool+Airport+night+time+surveys+letter_October+2024.pdf"
        }
    ],

    targetedConsultation: [
        {
            title: "Annex 1a: Supporting information on the proposed minor onshore route amendments",
            url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/Annex+1a+Supporting+information+(1).pdf",
        },
        {
            title: "Annex 2a: Map Book - Overview",
            url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/Annnex+2a+Map+Book+-+Overview+only+(1).pdf",
        },
        {
            title: "Annex 2b: Detailed Map Book",
            url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/Annnex+2b+-+Detailed+Map+Book+(1).pdf",
        },
        {
            title: "Annex 3: EIA Table (including cover sheet)",
            url: "https://bp-mmt.s3.eu-west-2.amazonaws.com/transmission/Annex+3+EIA+Assessment+Table.xlsx",
        },

    ],

    statConsultation: [
        {
            title: "Statement of Community Consultation (SoCC)",
            url: "/assets/images/transmission/pdf/M&M-TRANSMISSION-SoCC-pages.pdf",
        },
        {
            title: "Section 47 Notice",
            url: "/assets/images/transmission/pdf/TransmissionAssets-S47.pdf",
        },

    ],

    nonstatConsultationMaterials23: [
        {
            title: "Non-statutory consultation brochure (Single pages)",
            url: "/assets/images/shared/downloads/transmission/MM-TRANS-Brochure-V6_pages.pdf",
        },
        {
            title: "Non-statutory consultation brochure (Spread pages)",
            url: "/assets/images/shared/downloads/transmission/MM-TRANS-Brochure-V6_spreads.pdf",
        },
        {
            title: "Non-statutory feedback form",
            url: "/assets/images/shared/downloads/transmission/MMMT-Feedback Form-V6.pdf",
        },
        {
            title: "Consultation Poster",
            url: "/assets/images/shared/downloads/MMMT-Poster.pdf",
        },
        {
            title: "Morgan and Morecambe Offshore Wind Farms: Transmission Assets Webinar - 23rd May 2023",
            videoId: "830262025",
            type: "video",
        },
    ],

    nonstatConsultationMaterials: [
        {
            title: "Morecambe and Morgan consultation brochure - Autumn 2022",
            url: "/assets/images/shared/downloads/M&M-Condoc.pdf",
        },
        {
            title: "Recording of online consultation event",
            videoId: "774795335",
            type: "video",
        },
    ],

    scoping: [
        {
            title: "Transmission Assets EIA Scoping Report",
            url: "/assets/images/shared/downloads/transmission/Morgan-and-Morecambe-Offshore-Wind-Farms-Transmission-Assets-EIA-Scoping-Report.pdf",
        },
    ],

    faqs: [
        {
            "question": "1. Why are we collecting this data?",
            sections: [
                {
                    "text": "We value your feedback to help us develop our proposals for the Morgan and Morecambe Offshore Wind Farms: Transmission Assets."
                },
                {
                    "text": "To allow us to keep you up to date as the project progresses. "
                },
                {
                    "text": "To meet our statutory obligations under the Planning Act 2008 and any other relevant legislation."
                }
            ]
        },
        {
            "question": "2. Who are we sharing this information with?",
            sections: [
                {
                    "text": "With our contractors and suppliers with whom we have contracts in place to support in the development of the project. For example, Camargue, RPS and Royal HaskoningDHV who act on behalf of Morgan and Morecambe Offshore Wind Farms: Transmission Assets."
                },
                {
                    "text": "With relevant government bodies, such as the Planning Inspectorate and the Department of Energy Security and Net Zero, to support the project planning application process."
                }
            ]
        },
        {
            "question": "3. How long will we keep this information?",
            sections: [
                {
                    "text": "We will keep the information for the time required to fulfil the purposes of the project."
                }
            ]
        },
    ],
};
